<style>
.prompt-textarea .form-control {
  font-size: 17px;
}

</style>
<template>
    <div>

        <CRow>
            <CCol lg="12">
                <CButton @click="$router.go(-1)" size="sm" color="warning">
                    <font-awesome-icon icon="arrow-left" /> Go back
                </CButton>
            </CCol>
        </CRow>
        <br>
        <CRow>
            <CCol :lg="7">
                <CCard :key="update_key">
                    <CCardHeader><font-awesome-icon icon="cog" /> Manage AI Model
                        <template v-if="ai_model.status == 'Active'">
                            <CButton size="sm" color="danger" class="float-right"
                                @click="toggleEdit(), returnInformation()" v-show="edit">
                                <font-awesome-icon icon="window-close" /> Cancel
                            </CButton>
                            <CButton v-if="$store.getters['can']('update-document-template-prompt')" size="sm"
                                :disabled="!isValid" color="success" class="float-right" v-show="edit"
                                @click="updateAIModel()">
                                <font-awesome-icon icon="save" /> Update
                            </CButton>
                            <CButton v-if="$store.getters['can']('edit-document-template-prompt')" size="sm"
                                color="info" class="float-right" @click="toggleEdit" v-show="!edit">
                                <font-awesome-icon icon="edit" /> Edit
                            </CButton>
                        </template>
                        <template v-if="ai_model.status == 'Archived'">
                            <CButton v-if="$store.getters['can']('restore-document-template-prompt')" size="sm"
                                color="success" class="float-right" @click="restore()">
                                <font-awesome-icon icon="trash-restore" /> Restore
                            </CButton>
                        </template>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol lg="6">
                                <CInput :lazy="false" label="Name" type="text" :disabled="!edit" autocomplete="off"
                                    v-model="ai_model.name"
                                    invalidFeedback="Must be three(3) characters."
                                    :value.sync="$v.ai_model.name.$model"
                                    :isValid="checkIfValid($v.ai_model, 'name')" />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol lg="12" md="12" xl="12">
                            <CSelect label="Provider" :options="providerOptions" :disabled="!edit"
                                :value.sync="$v.ai_model.provider.$model"
                                :isValid="checkIfValid($v.ai_model, 'provider')" />
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow v-show="edit">
            <CCol lg="8">
                <CCard borderColor="danger" v-if="$store.getters['can']('archive-document-template-prompt')">
                    <CCardHeader>
                        <font-awesome-icon icon="exclamation" :style="{ color: 'red' }" />
                        Danger Zone
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol lg="8">
                                <h6>Archive this AI Model?</h6>
                            </CCol>
                            <CCol lg="12">
                                <label> Once archived, you cannot use this AI Model anymore. Please be certain.</label>
                            </CCol>
                        </CRow>
                        <br>
                        <CRow>
                            <CCol lg="3">
                                <CButton shape="pill" color="warning" @click="archive()">
                                    <font-awesome-icon icon="minus-square" /> Archived
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
export default {
    name: 'AMEdit',
    data() {
        return {
            ai_model: {
                name: '',
                provider: '',
            },
            providerOptions: ['OpenAI', 'Google'],
            ai_model_backup: {},
            disable: 1,
            edit: false,
            ai_model_fields: [
                { key: 'name', label: 'Name' },
                { key: 'provider', label: 'Provider' },
                { key: 'action', _style: 'width:20%', sorter: false }
            ],
            my_tab: null,
            update_key: 0,
        }
    },
    computed: {
        isValid() { return !this.$v.ai_model.$invalid },
        isDirty() { return this.$v.ai_model.$anyDirty },
        ai_model_inactive: function () {
            return this.ai_model.prompt_items.filter((item) => item.deleted_at != null);
        },

        ai_model_active: function () {
            return this.ai_model.prompt_items.filter((item) => item.deleted_at == null);

        },
    },
    created() {
        this.getAIModel();
    },
    validations: {
        ai_model: {
            name: { required, minLength: minLength(3) },
            provider: { required },
        },
    },
    methods: {
        archive: function () {
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: `You are trying to archive the ${this.ai_model.name}`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()
                    return axios.post('drs/ai-model/archive/' + this.$route.params.id, { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.update_key++;
                                this.ai_model_backup.status = 'Archived'
                                this.returnInformation()
                                this.toggleEdit()
                                this.$Progress.finish()
                                this.$swal({
                                    toast: true,
                                    position: 'top-right',
                                    timer: 3000,
                                    icon: 'success',
                                    title: `${this.ai_model.name} successfully archived.`,
                                    showConfirmButton: false,
                                    timerProgressBar: true,
                                })
                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
        },
        restore: function () {
            this.$Progress.start()
            axios.post('drs/ai-model/restore/' + this.$route.params.id, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        this.update_key++;
                        this.ai_model_backup.status = 'Active'
                        this.returnInformation()
                        // this.toggleEdit()
                        this.$Progress.finish()

                        this.$swal({
                            toast: true,
                            position: 'top-right',
                            timer: 3000,
                            icon: 'success',
                            title: `${this.ai_model.name} restored successfully.`,
                            showConfirmButton: false,
                            timerProgressBar: true,
                        })
                    }
                })
        },
        getAIModel: function () {
            axios.get('drs/ai-model/' + this.$route.params.id, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        const data = response.data.data;

                        this.ai_model.name = response.data.data.name
                        this.ai_model.provider = response.data.data.provider
                        this.ai_model.status = response.data.data.deleted_at ? "Archived" : "Active";


                        this.ai_model_backup = JSON.parse(JSON.stringify(this.ai_model))

                        this.$nextTick(() => {
                            this.disableWatcher = false;
                        });
                    }
                })
        },
        returnInformation: function () {
            this.ai_model = JSON.parse(JSON.stringify(this.ai_model_backup))
        },
        updateAIModel: function () {

            if (JSON.stringify(this.ai_model) == JSON.stringify(this.ai_model_backup)) {
                this.$swal({
                    icon: "info",
                    title: "Opps!",
                    text: "No changes has been made.",
                })
                return;
            }
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: `You are trying to update the ${this.ai_model.name}`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()

                    return axios.post('drs/ai-model/update/' + this.$route.params.id, this.ai_model, { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.$swal({
                                    toast: true,
                                    position: 'top-right',
                                    timer: 3000,
                                    icon: 'success',
                                    title: `${this.ai_model.name} successfully updated.`,
                                    showConfirmButton: false,
                                    timerProgressBar: true,
                                })
                                this.update_key++;

                                this.ai_model.name = response.data.data.name
                                this.ai_model.status = response.data.data.deleted_at ? "Archived" : "Active";
                                this.ai_model_backup = JSON.parse(JSON.stringify(this.ai_model))
                                this.returnInformation()
                                this.toggleEdit()
                                this.getAIModel();
                                this.$Progress.finish()
                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
        },
        toggleEdit: function () {
            this.edit = !this.edit
            this.disable = (this.disable + 1) % 2
            if (!this.disable) {
                this.$v.ai_model.$touch()
                this.$v.$touch()
            }
            else {
                this.$v.ai_model.$reset()
                this.$v.$reset()

            }
        },
        checkIfValidModified(object, fieldName) {
            const field = object?.[fieldName];
            if (!field || !field.$dirty) return null;
            return !(field.$invalid || field.$model == '');
        },
        resetPrompt: function () {
            this.ai_model = {
                name: '',
                provider: '',
            }
        },
        changeTab: function (item) {
            this.my_tab = item
        },
    }
}
</script>
